import React, { useEffect, useState } from "react";
import BaseURL from "../../assets/utils/baseUrl";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import { useLocation, useParams } from "react-router-dom";

function AgendaDetail() {
  useDocumentTitle("Agenda - BAPENDA BEKASI");

  const { id } = useParams(); // ✅ FIX DI SINI
  const [informasi, setInformasi] = useState(null);
  const location = useLocation();

  /* ── FETCH DATA ── */
  useEffect(() => {
    const getData = async () => {
      try {
        const res = await fetch(
          BaseURL + "index.php/api/Agenda?key=bapenda123&id=" + id
        );
        const data = await res.json();

        setInformasi(data?.data?.[0] || null);
      } catch (err) {
        console.log("Error:", err);
        setInformasi(null);
      }
    };

    getData();

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, [id, location]);

  /* ── PARSE KONTEN ── */
  const renderKonten = () => {
    if (!informasi?.konten) return null;

    return informasi.konten.split("(_newline)").map((item, i) => (
      <p className="informasi-detail-desc" key={i}>
        {item}
      </p>
    ));
  };

  /* ───────────────────────── */

  return (
    <div className="page">
      <Header active="publikasi" />

      <div className="main-sb">
        <div className="content">
          <Breadcrumb path={informasi?.judul || "Agenda"} parent="agenda" />

          <div className="informasi-detail-wrapper">
            <p className="informasi-detail-title">
              {informasi?.judul || "Loading..."}
            </p>

            <p className="informasi-detail-date">
              {informasi?.created_date || "-"} | {informasi?.nama || "-"}
            </p>

            <div className="informasi-detail-image-wrapper">
              <img
                src={
                  informasi?.thumbnail
                    ? BaseURL +
                      "assets/images/agenda/" +
                      informasi.thumbnail
                    : "/no-image.png"
                }
                className="informasi-detail-image"
                alt={informasi?.judul}
              />
            </div>

            <div className="informasi-detail-desc-wrapper">
              {renderKonten()}
            </div>
          </div>
        </div>

        <Sidebar />
      </div>

      <Footer />
    </div>
  );
}

export default AgendaDetail;